module.exports = __webpack_public_path__ + "img/img21.e714b1b6.svg";